'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const faqItems = [
  { question: 'How to search free Mangalashtak pdf of Vadhu Var list?', answer: 'Marathi grooms and brides can register free on MarathiVadhuVarSuchak.com to search Marathi Vadhu Var profiles.' },
  { question: 'Which is the trusted Mangalashtak Matrimony Site in Pune?', answer: 'MarathiVadhuVarSuchak.com is the most trusted Marathi Vadhu Var Suchak Mandal for free registration.' },
  { question: 'How to do Mangalashtak Matrimony Login online?', answer: 'Marathi grooms and brides can register through MarathiVadhuVarSuchak.com and login with your credentials.' },
  { question: 'Which is the best Mangalashtak Vadhu Var Suchak in Mumbai?', answer: 'For Marathi Vadhu Var from Mumbai can sign up for free on MarathiVadhuVarSuchak.com Marathi matrimonial app.' },
  { question: 'Which is the most trusted Mangalashtak Vadhu Var Suchak Mandal in Maharashtra?', answer: 'From trust point of view, MarathiVadhuVarSuchak.com matrimony is the most trusted Marathi Vadhu Var Suchak Mandal in Maharashtra state.' },
  { question: 'How to do search for best Marathi Mangalashtak Vadhu Var Kendra?', answer: 'Visit MarathiVadhuVarSuchak.com matrimonial site for free registration, which No.1 Marathi matrimony in Maharashtra state.' },
  { question: 'How to download Mangalashtak in Marathi?', answer: 'Visit MarathiVadhuVarSuchak.com matrimonial site for free Marathi Mangalashtak PDF download.' },
  { question: 'How to download free Wedding Mangalashtak online?', answer: 'You can download Marathi Wedding Mangalashtak online from MarathiVadhuVarSuchak.com matrimonial portal.' },
];

const communityServices: { label: string; href?: string }[] = [
  { label: "Mangalashtak Marathi" },
  { label: "Mangalashtak Once More" },
  { label: "Tulsi Vivah Mangalashtak" },
  { label: "Tulsi Vivah Mangalashtak Marathi" },
  { label: "Mangalashtak pdf" },
  { label: "Mangalashtak in Marathi" },
  { label: "Mangalashtak Tulsi Vivah" },
  { label: "Mangalashtak Stotra" },
  { label: "Wedding Mangalashtak" },
  { label: "New Mangalashtak in Marathi" },
  { label: "Mangalashtak Matrimony Site" },
  { label: "Mangalashtak Matrimony Login" },
  { label: "Mangalashtak Vadhu Var Suchak" },
  { label: "Mangalashtak Vadhu Var Suchak Mandal" },
  { label: "Marathi Mangalashtak Vadhu Var" },
];

export default function MarathiMangalashtakMatrimonyClient() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      <Header variant="transparent" />

      <HomeHeroSection
        title="मराठी समाजातील वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="marathi_mangalashtak_matrimony"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Frequently Asked Questions</h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {faqItems.map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">{faq.question}</h3>
                    <svg className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openFAQ === index ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div className={`px-6 transition-all duration-300 ease-in-out ${openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Marathi Mangalashtak Matrimony for Marathi Communities"
        items={communityServices}
      />

    </div>
  );
}
